<template>
  <div>
    <aside class="main-sidebar sidebar-dark-primary elevation-4">
      <a data-widget="pushmenu" href="#" class="nav-link show-on-desktop text-right"><i class="fas fa-arrow-left"></i></a>
      <!-- Brand Logo -->
      <a hre="javascript;" @click="checkRoleUserAndRouterGo" class="brand-link">
        <div class="login-logo"><img :src="'./images/logo.png'"/></div>
      </a>
      <!-- Sidebar -->
      <div class="sidebar">
        <div class="user-panel mt-3 pb-3 mb-3 d-flex">
          <div class="image">
             <!-- <slot v-if="authUser.image">
              <img :src="$image_path + authUser.image" class="img-circle" style="width:60px; height: 40px;"> 
            </slot> -->
             <!-- <slot v-else> -->
              <img :src="'./images/avatar.png'" class="img-circle elevation-2" alt="User Image">
            <!-- </slot> -->
          </div>
          <div class="info">
            <a href="#" class="d-block">{{ authUser.name }}</a>
          </div>
        </div>
        <nav class="mt-3">
          <ul class="nav nav-pills nav-sidebar flex-column nav-flat" role="menu">
            <li class="nav-item" v-for="(menu, index) in menuList" :key="index">
              <router-link :to="menu.url" class="nav-link">
                <i class="far fa-circle nav-icon"></i>
                <p>{{ locale == 'bn' ? menu.name_bn : menu.name }}</p>
              </router-link>
            </li>
            <li class="nav-item has-treeview"
              v-for="(menuModule, indx) in moduleMenuList"
              :key="'D' + indx"
              :class="{ 'menu-open': subMenuKey === indx && subMenu }"
            >
              <a href="#" class="nav-link" @click.prevent="checkSubmenu(indx)">
                <i class="nav-icon far fa-plus-square"></i>
                <p>
                  {{ locale == 'bn' ? menuModule.module_name_bn : menuModule.module_name }}
                  <i class="fas fa-angle-left right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item" v-for="(tmpMenu, key) in menuModule.menus" :key="'tree-'+ key">
                  <router-link :to="tmpMenu.url" class="nav-link">
                    <i class="far fa-circle text-yellow nav-icon"></i>
                    <p>{{ locale == 'bn' ? tmpMenu.name_bn : tmpMenu.name }}</p>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link" @click.prevent="logout">
                <i class="nav-icon fas fa-sign-out-alt"></i>
                <p>Sign Out</p>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  </div>
</template>
<script>
import config from '../config'
export default {
  name:'Sidebar',
  data(){
    return {
      subMenuKey: 0,
      subMenu: false,
      moduleMenu: false,
      inactivityTimeout: null,
      maxInactivityTime: 15 * 60 * 1000, // 15 minutes in milliseconds
    }
  },
  watch: {
    $route () {
      if (window.innerWidth <= 992) {
        document.body.classList.remove('sidebar-open')
        document.body.classList.add('sidebar-closed')
      }
    }
  },
  computed : {
    menuList: function () {
      return this.$store.state.menus.commonMenus
    },
    moduleMenuList: function () {
      return this.$store.state.menus.moduleMenus
    },
    loading: function () {
      return this.$store.state.loading
    },
    locale () {
      return this.$store.state.language
    },
    authUser () {
      return this.$store.state.authUser
    }
  },
  methods: {
    checkSubmenu (key) {
      if (this.subMenuKey === key) {
        this.subMenu = !this.subMenu
      } else {
        this.subMenuKey = key
        this.subMenu = true
      }
    },
    getPermission() {
      this.$store.dispatch('loadingState',  true)
      config.getData("/user/permissions")
      .then((response) => {
        if (response.status == 200) {
          this.$store.dispatch('loadingState',  false)
          window.Permissions = response.data;
        }
      })  
    },
    checkRoleUserAndRouterGo () {
      const roleId = this.authUser.role_id
      if (roleId == 1 || roleId == 6) {
        this.$router.push('/')
      } else if (roleId == 7) {
        this.$router.push('/hub-dashboard')
      } else {
        this.$router.push('/operational-dashboard')
      }
    },
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimeout);
      this.inactivityTimeout = setTimeout(this.logout, this.maxInactivityTime);
    },
    logout(){
      this.$router.push('/auth/login');
      config.postData('/admin/logout')
      .then(() => { 
        this.$store.dispatch('setMenu', [])
        // this.$store.dispatch('setRoleStatusList', [])
        this.$store.dispatch('setAuthUser', '')
        localStorage.removeItem('accessToken');    
      })      
    }
  }
}
</script>
<style scoped>
.main-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;       /* full height */
  overflow-y: auto;    /* scroll if content grows */
  overflow-x: hidden;  /* prevent horizontal scroll */
}
.show-on-desktop {
  display: none;
}
@media screen and (max-width: 480px) {
    .show-on-desktop {
      display: block;
    }
}
</style>
